const roundTo = require('round-to');

export default class Filters {
    static formatFloat(value) {
        return parseFloat(value).toFixed(2);
    }

    static pad(num) {
        return ('0' + num).slice(-2);
    }

    static hhmmss(seconds) {
        var minutes = Math.floor(seconds / 60);
        seconds = seconds % 60;
        var hours = Math.floor(minutes / 60);
        minutes = minutes % 60;
        return `${this.pad(hours)}:${this.pad(minutes)}:${this.pad(seconds)}`;
    }

    static distance(distanceInMeters) {
        if (distanceInMeters >= 1000) {
            return roundTo(distanceInMeters / 1000, 2) + ' km';
        }

        return distanceInMeters + ' m';
    }
}
